import { AnimatePresence } from 'framer-motion';
import React from 'react';

function AnimatedContainer(props) {
  return /*#__PURE__*/React.createElement(AnimatePresence, Object.assign({
    initial: false
  }, props));
}

export default AnimatedContainer;